import { ChartTimelineVariantShimmerIcon } from './ChartTimelineVariantShimmerIcon';

/**
 * author: Google
 * id F2256261-8218-48B2-BACA-9E23E42EEC15
 * name chart-timeline-variant-shimmer
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-timeline-variant-shimmer.svg
 * tags
 * - Math 
 */
export const GraphTimelineVariantShimmerIcon = ChartTimelineVariantShimmerIcon;
export default GraphTimelineVariantShimmerIcon